// extracted by mini-css-extract-plugin
export var buttonForImage = "component-module--buttonForImage--14b0e";
export var buttonForVideo = "component-module--buttonForVideo--16af9";
export var fullWidthImage = "component-module--fullWidthImage--e1230";
export var fullWidthVideo = "component-module--fullWidthVideo--fafec";
export var imageContainer = "component-module--imageContainer--606d6";
export var imageWrapper = "component-module--imageWrapper--8e3ef";
export var mediaTextAdvancedContainer = "component-module--mediaTextAdvancedContainer--689ff";
export var mediaTextAdvancedImageDesc = "component-module--mediaTextAdvancedImageDesc--f10f7";